import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardApprovalService } from '../../services/wealthlane-award-services';

const useRsuAwardParticipantApprovalStatusOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const rsuAwardParticipantApprovalStatus = useQuery(
    ['getRsuAwardParticipantApprovalStatus'],
    async () => {
      return await handleRequest(
        RsuAwardApprovalService.getApiAwardApiAppRSUAwardApprovalRSUAwardStatuses()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return rsuAwardParticipantApprovalStatus;
};

export default useRsuAwardParticipantApprovalStatusOptions;
